import {
  CloseIcon,
  createStyles,
  Grid,
  IconButton,
  makeStyles,
  Popup,
  PopupContent,
  PopupHeader,
  StatusBox,
  Theme,
  Typography,
} from '@freighthub/silhouette-core'
import { entries } from 'lodash-es'
import { FC, useState } from 'react'
import { useI18n } from 'utils/localisation'

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    popupInfoHeader: {
      paddingRight: 0,
    },
    popupInfoTrigger: {
      cursor: 'pointer',
      textDecoration: 'underline',
      textTransform: 'lowercase',
    },
    iconButton: {
      color: 'inherit',
    },
    infoList: {
      margin: 0,
      padding: theme.spacing(0, 2),
    },
  })
)

type LegalEntityInfoTranslations = {
  header: string
  terms: string[]
}

const legalEntityInfoTranslationsMap: Record<string, LegalEntityInfoTranslations> = {
  paymentTerms: {
    header: 'directory-legal_entity_info_payment_terms',
    terms: [
      'directory-legal_entity_info_payment_terms_first_item',
      'directory-legal_entity_info_payment_terms_second_item',
    ],
  },
  billingTerms: {
    header: 'directory-legal_entity_info_billing_terms',
    terms: [
      'directory-legal_entity_info_billing_terms_first_item',
      'directory-legal_entity_info_billing_terms_second_item',
      'directory-legal_entity_info_billing_terms_third_item',
    ],
  },
}

export const LegalEntityInfo: FC = () => {
  const { translate } = useI18n()
  const classes = useStyles()
  const [anchor, setAnchor] = useState<HTMLDivElement | null>(null)
  const isPopupOpen = Boolean(anchor)

  const handleClick = (evt) => setAnchor(evt.currentTarget)

  const handleClose = () => setAnchor(null)

  return (
    <>
      <StatusBox variant="warning" fullWidth icon>
        {translate('directory-legal_entity_info_message_intro')}{' '}
        <span className={classes.popupInfoTrigger} onClick={handleClick}>
          {translate('directory-legal_entity_info_header')}
        </span>
        {'. '}
        {translate('directory-legal_entity_info_message_continuation')}
      </StatusBox>

      <Popup
        anchorEl={anchor}
        open={isPopupOpen}
        onClickAway={handleClose}
        height="auto"
        width={500}
        placement="bottom-end"
      >
        <PopupHeader className={classes.popupInfoHeader}>
          <Typography>{translate('directory-legal_entity_info_header')}</Typography>

          <IconButton onClick={handleClose} className={classes.iconButton}>
            <CloseIcon />
          </IconButton>
        </PopupHeader>

        <PopupContent alignItems="center" p={2}>
          <Grid spacing={2} direction="column" container>
            {entries(legalEntityInfoTranslationsMap).map(([infoTitle, { header, terms }]) => (
              <Grid key={infoTitle} xs={12}>
                <Typography variant="subtitle1">{translate(header)}</Typography>
                <ul className={classes.infoList}>
                  {terms.map((term) => (
                    <li key={term}>
                      <Typography variant="body2">{translate(term)}</Typography>
                    </li>
                  ))}
                </ul>
              </Grid>
            ))}
          </Grid>
        </PopupContent>
      </Popup>
    </>
  )
}
